import {
    PENDING_LEADS, SUCCESS_LEADS, ERROR_LEADS, PENDING_ORDER_LIST, SUCCESS_ORDER_LIST, ERROR_ORDER_LIST, PENDING_RANNKAAR_LIST,
    SUCCESS_RANNKAAR_LIST, ERROR_RANNKAAR_LIST, PENDING_PREBOOK_LIST, SUCCESS_PREBOOK_LIST, ERROR_PREBOOK_LIST, PENDING_ENQUIRY_LIST, SUCCESS_ENQUIRY_LIST,
    ERROR_ENQUIRY_LIST, PENDING_PREBOOK_DETAILS, SUCCESS_PREBOOK_DETAILS, ERROR_PREBOOK_DETAILS, PENDING_UPDATE_PREBOOK_DETAILS, SUCCESS_UPDATE_PREBOOK_DETAILS,
    ERROR_UPDATE_PREBOOK_DETAILS, PENDING_APPOINTMENT_LIST, SUCCESS_APPOINTMENT_LIST, ERROR_APPOINTMENT_LIST, PENDING_CALLBACK_LIST, SUCCESS_CALLBACK_LIST,
    ERROR_CALLBACK_LIST, PENDING_STORE_MASTER_LIST, SUCCESS_STORE_MASTER_LIST, ERROR_STORE_MASTER_LIST, PENDING_CITY_LIST, SUCCESS_CITY_LIST, ERROR_CITY_LIST,
    PENDING_STORE_LIST, SUCCESS_STORE_LIST, ERROR_STORE_LIST, PENDING_STORE_MASTER_BY_ID, SUCCESS_STORE_MASTER_BY_ID, ERROR_STORE_MASTER_BY_ID,
    PENDING_UPDATE_STORE_MASTER_DATA, SUCCESS_UPDATE_STORE_MASTER_DATA, ERROR_UPDATE_STORE_MASTER_DATA, PENDING_ADD_STORE_MASTER_DATA,
    SUCCESS_ADD_STORE_MASTER_DATA, ERROR_ADD_STORE_MASTER_DATA, PENDING_ADD_GOLD_RATE, SUCCESS_ADD_GOLD_RATE, ERROR_ADD_GOLD_RATE,
    SUCCESS_GET_GOLD_RATE, ERROR_GET_GOLD_RATE, PENDING_GET_GOLD_RATE, PENDING_GET_IS_USER_LIVE, SUCCESS_GET_IS_USER_LIVE, ERROR_GET_IS_USER_LIVE,
    PENDING_UPDATE_BULK_STORE_MASTER_DATA, SUCCESS_UPDATE_BULK_STORE_MASTER_DATA, ERROR_UPDATE_BULK_STORE_MASTER_DATA, PENDING_EVENT_CAMPAIGN_LIST,
    SUCCESS_EVENT_CAMPAIGN_LIST, ERROR_EVENT_CAMPAIGN_LIST, PENDING_USERS_LIST, SUCCESS_USERS_LIST, ERROR_USERS_LIST, PENDING_CHECK_EMAIL, SUCCESS_CHECK_EMAIL,
    ERROR_CHECK_EMAIL, PENDING_ADD_USER, SUCCESS_ADD_USER, ERROR_ADD_USER, PENDING_UPDATE_USER, SUCCESS_UPDATE_USER, ERROR_UPDATE_USER, PENDING_USER_BY_ID, SUCCESS_USER_BY_ID,
    ERROR_USER_BY_ID, PENDING_DELETE_USER, SUCCESS_DELETE_USER, ERROR_DELETE_USER, PENDING_STORE_MASTER_LOGIN_LIST, SUCCESS_STORE_MASTER_LOGIN_LIST, ERROR_STORE_MASTER_LOGIN_LIST,
    PENDING_NSO_CAMPAIGN_LIST, SUCCESS_NSO_CAMPAIGN_LIST, ERROR_NSO_CAMPAIGN_LIST, PENDING_FEEDBACK_LIST, SUCCESS_FEEDBACK_LIST, ERROR_FEEDBACK_LIST,
    PENDING_SALE_LIST, SUCCESS_SALE_LIST, ERROR_SALE_LIST, PENDING_CUSTOMER_CART_DETAILS, SUCCESS_CUSTOMER_CART_DETAILS, ERROR_CUSTOMER_CART_DETAILS,
    PENDING_TRY_ON_VIDEO_ASSISTANCE_LIST, SUCCESS_TRY_ON_VIDEO_ASSISTANCE_LIST, ERROR_TRY_ON_VIDEO_ASSISTANCE_LIST, PENDING_MAKE_TO_ORDER_JEWELS_LIST,
    SUCCESS_MAKE_TO_ORDER_JEWELS_LIST, ERROR_MAKE_TO_ORDER_JEWELS_LIST, PENDING_LIKE_PRODUCT_LIST, SUCCESS_LIKE_PRODUCT_LIST, ERROR_LIKE_PRODUCT_LIST,
    PENDING_WISH_LIST, SUCCESS_WISH_LIST, ERROR_WISH_LIST, PENDING_QR_CODE_LIST, SUCCESS_QR_CODE_LIST, ERROR_QR_CODE_LIST, PENDING_DELETE_QR_CODE, SUCCESS_DELETE_QR_CODE, ERROR_DELETE_QR_CODE,
    PENDING_SCAN_BAR_CODE_LIST, SUCCESS_SCAN_BAR_CODE_LIST, ERROR_SCAN_BAR_CODE_LIST, PENDING_UPDATE_BULK_BARCODE, SUCCESS_UPDATE_BULK_BARCODE, ERROR_UPDATE_BULK_BARCODE,
    PENDING_FEEDBACK_JH_LIST, SUCCESS_FEEDBACK_JH_LIST, ERROR_FEEDBACK_JH_LIST, PENDING_MAKE_TO_ORDER_JH_LIST, SUCCESS_MAKE_TO_ORDER_JH_LIST, ERROR_MAKE_TO_ORDER_JH_LIST,
    PENDING_FESTIVE_FEEDBACK_LIST, SUCCESS_FESTIVE_FEEDBACK_LIST, ERROR_FESTIVE_FEEDBACK_LIST, PENDING_FESTIVE_AD_LIST, SUCCESS_FESTIVE_AD_LIST, ERROR_FESTIVE_AD_LIST,
    PENDING_NPS_FEEDBACK_LIST, SUCCESS_NPS_FEEDBACK_LIST, ERROR_NPS_FEEDBACK_LIST, PENDING_ADD_CALL_SLOT, SUCCESS_ADD_CALL_SLOT, ERROR_ADD_CALL_SLOT,
    PENDING_CTA_LIST, SUCCESS_CTA_LIST, ERROR_CTA_LIST
} from "../actions/types";

const initialState = {
    order_list: [],
};
// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
    switch (action.type) {

        case PENDING_LEADS:
            return {
                ...state,
                pending_leads: true,
                error_leads: null
            }
        case SUCCESS_LEADS:
            return {
                ...state,
                leads: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data.leads : [],
                pending_leads: false,
                error_leads: null
            }

        case ERROR_LEADS:
            return {
                ...state,
                error_leads: action?.payload,
                pending_leads: false,
            }

        case PENDING_ORDER_LIST:
            return {
                ...state,
                pending_order_list: true,
                error_order_list: null
            }
        case SUCCESS_ORDER_LIST:
            return {
                ...state,
                order_list: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_order_list: false,
                error_order_list: null
            }

        case ERROR_ORDER_LIST:
            return {
                ...state,
                error_order_list: action?.payload,
                pending_order_list: false,
            }
        case PENDING_RANNKAAR_LIST:
            return {
                ...state,
                pending_leafLet_list: true,
                error_leafLet_list: null
            }
        case SUCCESS_RANNKAAR_LIST:
            return {
                ...state,
                leafLet_list: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_leafLet_list: false,
                error_leafLet_list: null
            }

        case ERROR_RANNKAAR_LIST:
            return {
                ...state,
                error_leafLet_list: action?.payload,
                pending_leafLet_list: false,
            }
        case PENDING_PREBOOK_LIST:
            return {
                ...state,
                pending_prebook_list: true,
                error_prebook_list: null
            }
        case SUCCESS_PREBOOK_LIST:
            return {
                ...state,
                prebook_list: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_prebook_list: false,
                error_prebook_list: null
            }

        case ERROR_PREBOOK_LIST:
            return {
                ...state,
                error_prebook_list: action?.payload,
                pending_prebook_list: false,
            }
        case PENDING_ENQUIRY_LIST:
            return {
                ...state,
                pending_enquiry_list: true,
                error_enquiry_list: null
            }
        case SUCCESS_ENQUIRY_LIST:
            return {
                ...state,
                enquiry_list: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_enquiry_list: false,
                error_enquiry_list: null
            }

        case ERROR_ENQUIRY_LIST:
            return {
                ...state,
                error_enquiry_list: action?.payload,
                pending_enquiry_list: false,
            }

        case PENDING_PREBOOK_DETAILS:
            return {
                ...state,
                pending_prebook_details: true,
                error_prebook_details: null
            }
        case SUCCESS_PREBOOK_DETAILS:
            return {
                ...state,
                prebook_details: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_prebook_details: false,
                error_prebook_details: null
            }

        case ERROR_PREBOOK_DETAILS:
            return {
                ...state,
                error_prebook_details: action?.payload,
                pending_prebook_details: false,
            }
        case PENDING_UPDATE_PREBOOK_DETAILS:
            return {
                ...state,
                pending_update_prebook_details: true,
                error_update_prebook_details: null
            }
        case SUCCESS_UPDATE_PREBOOK_DETAILS:
            return {
                ...state,
                update_prebook_details: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_update_prebook_details: false,
                error_update_prebook_details: null
            }

        case ERROR_UPDATE_PREBOOK_DETAILS:
            return {
                ...state,
                error_update_prebook_details: action?.payload,
                pending_update_prebook_details: false,
            }

        case PENDING_CALLBACK_LIST:
            return {
                ...state,
                pending_callback_list: true,
                error_callback_list: null
            }
        case SUCCESS_CALLBACK_LIST:
            return {
                ...state,
                callback_list: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_callback_list: false,
                error_callback_list: null
            }

        case ERROR_CALLBACK_LIST:
            return {
                ...state,
                error_callback_list: action?.payload,
                pending_callback_list: false,
            }
        case PENDING_APPOINTMENT_LIST:
            return {
                ...state,
                pending_appointment_list: true,
                error_appointment_list: null
            }
        case SUCCESS_APPOINTMENT_LIST:
            return {
                ...state,
                appointment_list: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_appointment_list: false,
                error_appointment_list: null
            }

        case ERROR_APPOINTMENT_LIST:
            return {
                ...state,
                error_appointment_list: action?.payload,
                pending_appointment_list: false,
            }

        case PENDING_STORE_MASTER_LIST:
            return {
                ...state,
                pending_store_master_list: true,
                error_store_master_list: null
            }
        case SUCCESS_STORE_MASTER_LIST:
            return {
                ...state,
                store_master_list: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_store_master_list: false,
                error_store_master_list: null
            }

        case ERROR_STORE_MASTER_LIST:
            return {
                ...state,
                error_store_master_list: action?.payload,
                pending_store_master_list: false,
            }

        case PENDING_CITY_LIST:
            return {
                ...state,
                pending_city_list: true,
                error_city_list: null
            }
        case SUCCESS_CITY_LIST:
            return {
                ...state,
                city_list: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_city_list: false,
                error_city_list: null
            }

        case ERROR_CITY_LIST:
            return {
                ...state,
                error_city_list: action?.payload,
                pending_city_list: false,
            }
        case PENDING_STORE_LIST:
            return {
                ...state,
                pending_store_list: true,
                error_store_list: null
            }
        case SUCCESS_STORE_LIST:
            return {
                ...state,
                store_list: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_store_list: false,
                error_store_list: null
            }

        case ERROR_STORE_LIST:
            return {
                ...state,
                error_store_list: action?.payload,
                pending_store_list: false,
            }
        case PENDING_STORE_MASTER_BY_ID:
            return {
                ...state,
                pending_store_master: true,
                error_store_list: null
            }
        case SUCCESS_STORE_MASTER_BY_ID:
            return {
                ...state,
                store_master: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_store_master: false,
                error_store_master: null
            }

        case ERROR_STORE_MASTER_BY_ID:
            return {
                ...state,
                error_store_master: action?.payload,
                pending_store_master: false,
            }
        case PENDING_UPDATE_STORE_MASTER_DATA:
            return {
                ...state,
                pending_update_store_master: true,
                error_update_store_master: null
            }
        case SUCCESS_UPDATE_STORE_MASTER_DATA:
            return {
                ...state,
                update_store_master: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_update_store_master: false,
                error_update_store_master: null
            }

        case ERROR_UPDATE_STORE_MASTER_DATA:
            return {
                ...state,
                error_update_store_master: action?.payload,
                pending_update_store_master: false,
            }
        case PENDING_ADD_STORE_MASTER_DATA:
            return {
                ...state,
                pending_add_store_master: true,
                error_add_store_master: null
            }
        case SUCCESS_ADD_STORE_MASTER_DATA:
            return {
                ...state,
                add_store_master: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_add_store_master: false,
                error_add_store_master: null
            }

        case ERROR_ADD_STORE_MASTER_DATA:
            return {
                ...state,
                error_add_store_master: action?.payload,
                pending_add_store_master: false,
            }

        case PENDING_ADD_GOLD_RATE:
            return {
                ...state,
                pending_add_gold_rate: true,
                error_add_gold_rate: null
            }
        case SUCCESS_ADD_GOLD_RATE:
            return {
                ...state,
                add_gold_rate: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_add_gold_rate: false,
                error_add_gold_rate: null
            }

        case ERROR_ADD_GOLD_RATE:
            return {
                ...state,
                error_add_gold_rate: action?.payload,
                pending_add_gold_rate: false,
            }
        case PENDING_GET_GOLD_RATE:
            return {
                ...state,
                pending_get_gold_rate: true,
                error_get_gold_rate: null
            }
        case SUCCESS_GET_GOLD_RATE:
            return {
                ...state,
                get_gold_rate: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_get_gold_rate: false,
                error_get_gold_rate: null
            }

        case ERROR_GET_GOLD_RATE:
            return {
                ...state,
                error_get_gold_rate: action?.payload,
                pending_get_gold_rate: false,
            }
        case PENDING_GET_IS_USER_LIVE:
            return {
                ...state,
                pending_is_user_live: true,
                error_is_user_live: null
            }
        case SUCCESS_GET_IS_USER_LIVE:
            return {
                ...state,
                is_user_live: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_is_user_live: false,
                error_is_user_live: null
            }

        case ERROR_GET_IS_USER_LIVE:
            return {
                ...state,
                error_is_user_live: action?.payload,
                pending_is_user_live: false,
            }
        case PENDING_UPDATE_BULK_STORE_MASTER_DATA:
            return {
                ...state,
                pending_bulk_update_store_master: true,
                error_bulk_update_store_master: null
            }
        case SUCCESS_UPDATE_BULK_STORE_MASTER_DATA:
            return {
                ...state,
                bulk_update_store_master: action.payload && action.payload.data && action.payload?.data?.count ? action.payload.data?.count : [],
                pending_bulk_update_store_master: false,
                error_bulk_update_store_master: null
            }

        case ERROR_UPDATE_BULK_STORE_MASTER_DATA:
            return {
                ...state,
                error_bulk_update_store_master: action?.payload,
                pending_bulk_update_store_master: false,
            }

        case PENDING_EVENT_CAMPAIGN_LIST:
            return {
                ...state,
                pending_campaign_list: true,
                error_campaign_list: null
            }
        case SUCCESS_EVENT_CAMPAIGN_LIST:
            return {
                ...state,
                campaign_list: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_campaign_list: false,
                error_campaign_list: null
            }

        case ERROR_EVENT_CAMPAIGN_LIST:
            return {
                ...state,
                error_campaign_list: action?.payload,
                pending_campaign_list: false,
            }
        case PENDING_USERS_LIST:
            return {
                ...state,
                pending_users_list: true,
                error_users_list: null
            }
        case SUCCESS_USERS_LIST:
            return {
                ...state,
                users_list: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_users_list: false,
                error_users_list: null
            }
        case PENDING_STORE_MASTER_LOGIN_LIST:
            return {
                ...state,
                pending_store_login: true,
                error_store_login: null
            }
        case SUCCESS_STORE_MASTER_LOGIN_LIST:
            return {
                ...state,
                store_login: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_store_login: false,
                error_store_login: null
            }

        case ERROR_STORE_MASTER_LOGIN_LIST:
            return {
                ...state,
                error_store_login: action?.payload,
                pending_store_login: false,
            }

        case ERROR_USERS_LIST:
            return {
                ...state,
                error_users_list: action?.payload,
                pending_users_list: false,
            }
        case PENDING_CHECK_EMAIL:
            return {
                ...state,
                pending_email_exist: true,
                error_email_exist: null
            }
        case SUCCESS_CHECK_EMAIL:
            return {
                ...state,
                email_exist: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_email_exist: false,
                error_email_exist: null
            }

        case ERROR_CHECK_EMAIL:
            return {
                ...state,
                error_email_exist: action?.payload,
                pending_email_exist: false,
            }
        case PENDING_USER_BY_ID:
            return {
                ...state,
                pending_users: true,
                error_users: null
            }
        case SUCCESS_USER_BY_ID:
            return {
                ...state,
                user_data: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_users: false,
                error_users: null
            }

        case ERROR_USER_BY_ID:
            return {
                ...state,
                error_users: action?.payload,
                pending_users: false,
            }
        case PENDING_ADD_USER:
            return {
                ...state,
                pending_add_users: true,
                error_add_users: null
            }
        case SUCCESS_ADD_USER:
            return {
                ...state,
                user_add_data: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_add_users: false,
                error_add_users: null
            }

        case ERROR_ADD_USER:
            return {
                ...state,
                error_add_users: action?.payload,
                pending_add_users: false,
            }
        case PENDING_DELETE_USER:
            return {
                ...state,
                pending_delete_user: true,
                error_delete_user: null
            }
        case SUCCESS_DELETE_USER:
            return {
                ...state,
                delete_user: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_delete_user: false,
                error_delete_user: null
            }

        case ERROR_DELETE_USER:
            return {
                ...state,
                error_delete_user: action?.payload,
                pending_delete_user: false,
            }
        case PENDING_UPDATE_USER:
            return {
                ...state,
                pending_update_users: true,
                error_update_users: null
            }
        case SUCCESS_UPDATE_USER:
            return {
                ...state,
                update_user: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_update_users: false,
                error_update_users: null
            }

        case ERROR_UPDATE_USER:
            return {
                ...state,
                error_update_users: action?.payload,
                pending_update_users: false,
            }
        case PENDING_NSO_CAMPAIGN_LIST:
            return {
                ...state,
                pending_campaign_list: true,
                error_campaign_list: null
            }
        case SUCCESS_NSO_CAMPAIGN_LIST:
            return {
                ...state,
                campaign_list: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_campaign_list: false,
                error_campaign_list: null
            }

        case ERROR_NSO_CAMPAIGN_LIST:
            return {
                ...state,
                error_campaign_list: action?.payload,
                pending_campaign_list: false,
            }
        case PENDING_LIKE_PRODUCT_LIST:
            return {
                ...state,
                pending_like_product_list: true,
                error_like_product_list: null
            }
        case SUCCESS_LIKE_PRODUCT_LIST:
            return {
                ...state,
                like_product_list: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_like_product_list: false,
                error_like_product_list: null
            }

        case ERROR_LIKE_PRODUCT_LIST:
            return {
                ...state,
                error_like_product_list: action?.payload,
                pending_like_product_list: false,
            }
        case PENDING_SALE_LIST:
            return {
                ...state,
                pending_sale_list: true,
                error_sale_list: null
            }
        case SUCCESS_SALE_LIST:
            return {
                ...state,
                sale_list: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_sale_list: false,
                error_sale_list: null
            }

        case ERROR_SALE_LIST:
            return {
                ...state,
                error_sale_list: action?.payload,
                pending_sale_list: false,
            }
        case PENDING_CUSTOMER_CART_DETAILS:
            return {
                ...state,
                pending_customer_cart_details: true,
                error_customer_cart_details: null
            }
        case SUCCESS_CUSTOMER_CART_DETAILS:
            return {
                ...state,
                customer_cart_details: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_customer_cart_details: false,
                error_customer_cart_details: null
            }

        case ERROR_CUSTOMER_CART_DETAILS:
            return {
                ...state,
                error_customer_cart_details: action?.payload,
                pending_customer_cart_details: false,
            }
        case PENDING_TRY_ON_VIDEO_ASSISTANCE_LIST:
            return {
                ...state,
                pending_try_on_video: true,
                error_try_on_video: null
            }
        case SUCCESS_TRY_ON_VIDEO_ASSISTANCE_LIST:
            return {
                ...state,
                try_on_video: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_try_on_video: false,
                error_try_on_video: null
            }

        case ERROR_TRY_ON_VIDEO_ASSISTANCE_LIST:
            return {
                ...state,
                error_try_on_video: action?.payload,
                pending_try_on_video: false,
            }
        case PENDING_MAKE_TO_ORDER_JEWELS_LIST:
            return {
                ...state,
                pending_maketo_order_rj: true,
                error_maketo_order_rj: null
            }
        case SUCCESS_MAKE_TO_ORDER_JEWELS_LIST:
            return {
                ...state,
                maketo_order_rj: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_maketo_order_rj: false,
                error_maketo_order_rj: null
            }

        case ERROR_MAKE_TO_ORDER_JEWELS_LIST:
            return {
                ...state,
                error_maketo_order_rj: action?.payload,
                pending_maketo_order_rj: false,
            }
        case PENDING_FEEDBACK_LIST:
            return {
                ...state,
                pending_feedback_list: true,
                error_feedback_list: null
            }
        case SUCCESS_FEEDBACK_LIST:
            return {
                ...state,
                feedback_list: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_feedback_list: false,
                error_feedback_list: null
            }

        case ERROR_FEEDBACK_LIST:
            return {
                ...state,
                error_feedback_list: action?.payload,
                pending_feedback_list: false,
            }
        case PENDING_WISH_LIST:
            return {
                ...state,
                pending_wish_list: true,
                error_wish_list: null
            }
        case SUCCESS_WISH_LIST:
            return {
                ...state,
                wish_list: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_wish_list: false,
                error_wish_list: null
            }

        case ERROR_WISH_LIST:
            return {
                ...state,
                error_wish_list: action?.payload,
                pending_wish_list: false,
            }
        case PENDING_QR_CODE_LIST:
            return {
                ...state,
                pending_qr_code_list: true,
                error_qr_code_list: null
            }
        case SUCCESS_QR_CODE_LIST:
            return {
                ...state,
                qr_code_list: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_qr_code_list: false,
                error_qr_code_list: null
            }

        case ERROR_QR_CODE_LIST:
            return {
                ...state,
                error_qr_code_list: action?.payload,
                pending_qr_code_list: false,
            }
        case PENDING_DELETE_QR_CODE:
            return {
                ...state,
                pending_delete_qr_code: true,
                error_delete_qr_code: null
            }
        case SUCCESS_DELETE_QR_CODE:
            return {
                ...state,
                delete_qr_code: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_delete_qr_code: false,
                error_delete_qr_code: null
            }

        case ERROR_DELETE_QR_CODE:
            return {
                ...state,
                error_delete_qr_code: action?.payload,
                pending_delete_qr_code: false,
            }
        case PENDING_SCAN_BAR_CODE_LIST:
            return {
                ...state,
                pending_scan_bar_code_list: true,
                error_scan_bar_code_list: null
            }
        case SUCCESS_SCAN_BAR_CODE_LIST:
            return {
                ...state,
                scan_bar_code_list: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_scan_bar_code_list: false,
                error_scan_bar_code_list: null
            }

        case ERROR_SCAN_BAR_CODE_LIST:
            return {
                ...state,
                error_scan_bar_code_list: action?.payload,
                pending_scan_bar_code_list: false,
            }
        case PENDING_UPDATE_BULK_BARCODE:
            return {
                ...state,
                pending_bulk_update_barcode: true,
                error_bulk_update: null
            }
        case SUCCESS_UPDATE_BULK_BARCODE:
            return {
                ...state,
                bulk_update_barcode: action.payload && action.payload.data && action.payload.data?.count ? action.payload?.data?.count : [],
                pending_bulk_update_barcode: false,
                error_bulk_update_barcode: null
            }

        case ERROR_UPDATE_BULK_BARCODE:
            return {
                ...state,
                error_bulk_update_barcode: action?.payload,
                pending_bulk_update_barcode: false,
            }
        case PENDING_FEEDBACK_JH_LIST:
            return {
                ...state,
                pending_feedback_jh_list: true,
                error_feedback_jh_list: null
            }
        case SUCCESS_FEEDBACK_JH_LIST:
            return {
                ...state,
                feedback_jh_list: action.payload && action.payload.data && action.payload.data?.data ? action.payload?.data?.data : [],
                pending_feedback_jh_list: false,
                error_feedback_jh_list: null
            }
        case ERROR_FEEDBACK_JH_LIST:
            return {
                ...state,
                error_feedback_jh_list: action?.payload,
                feedback_jh_list: false,
            }
        case PENDING_MAKE_TO_ORDER_JH_LIST:
            return {
                ...state,
                pending_jh_order_list: true,
                error_jh_order_list: null
            }
        case SUCCESS_MAKE_TO_ORDER_JH_LIST:
            return {
                ...state,
                jh_order_list: action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : [],
                pending_jh_order_list: false,
                error_jh_order_list: null
            }

        case ERROR_MAKE_TO_ORDER_JH_LIST:
            return {
                ...state,
                error_jh_order_list: action?.payload,
                pending_jh_order_list: false,
            }
        case PENDING_FESTIVE_FEEDBACK_LIST:
            return {
                ...state,
                pending_feed_back_list: true,
                error_feed_back_list: null
            }
        case SUCCESS_FESTIVE_FEEDBACK_LIST:
            return {
                ...state,
                feed_back_list: action.payload && action.payload.data && action.payload.data?.data ? action.payload?.data?.data : [],
                pending_feed_back_list: false,
                error_feed_back_list: null
            }
        case ERROR_FESTIVE_FEEDBACK_LIST:
            return {
                ...state,
                error_feed_back_list: action?.payload,
                feedback_feed_back_list: false,
            }
        case PENDING_FESTIVE_AD_LIST:
            return {
                ...state,
                pending_festive_ad_list: true,
                error_festive_ad_list: null
            }
        case SUCCESS_FESTIVE_AD_LIST:
            return {
                ...state,
                festive_ad_list: action.payload && action.payload.data && action.payload.data?.data ? action.payload?.data?.data : [],
                pending_festive_ad_list: false,
                error_festive_ad_list: null
            }
        case ERROR_FESTIVE_AD_LIST:
            return {
                ...state,
                error_festive_ad_list: action?.payload,
                festive_ad_list: false,
            }
        case PENDING_NPS_FEEDBACK_LIST:
            return {
                ...state,
                pending_nps_feedback_list: true,
                error_nps_feedback_list: null
            }
        case SUCCESS_NPS_FEEDBACK_LIST:
            return {
                ...state,
                nps_feedback_list: action.payload && action.payload.data && action.payload.data?.data ? action.payload?.data?.data : [],
                pending_nps_feedback_list: false,
                error_nps_feedback_list: null
            }
        case ERROR_NPS_FEEDBACK_LIST:
            return {
                ...state,
                error_nps_feedback_list: action?.payload,
                nps_feedback_list: false,
            }
        case PENDING_ADD_CALL_SLOT:
            return {
                ...state,
                pending_call_slot: true,
                error_call_slot: null
            }
        case SUCCESS_ADD_CALL_SLOT:
            return {
                ...state,
                call_slot: action.payload && action.payload.data && action.payload.data?.data ? action.payload?.data?.data : [],
                pending_call_slot: false,
                error_call_slot: null
            }
        case ERROR_ADD_CALL_SLOT:
            return {
                ...state,
                error_call_slot: action?.payload,
                call_slot: false,
            }
        case PENDING_CTA_LIST:
            return {
                ...state,
                pending_cta_list: true,
                error_cta_list: null
            }
        case SUCCESS_CTA_LIST:
            return {
                ...state,
                cta_list: action.payload && action.payload.data && action.payload.data?.data ? action.payload?.data?.data : [],
                pending_cta_list: false,
                error_cta_list: null
            }
        case ERROR_CTA_LIST:
            return {
                ...state,
                error_cta_list: action?.payload,
                cta_list: false,
            }

        default:
            return state
    }
}